import { Container, ContainerItem } from '../common/container/Container'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import { FORM_API_KEY, FORM_SERVICE_KEY } from '../modules/Form'
import { FomrProps, FORMS_MODULE } from '../modules/Form/container'
import { FormService } from '../modules/Form/services/FormService'
import { FormApi } from '../modules/Form/api/FormApi'

let container: Container

function init(p: FomrProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(FORM_API_KEY, new ContainerItem({ instance: new FormApi() }))
  items.set(
    FORM_SERVICE_KEY,
    new ContainerItem({
      instance: new FormService({ apiKey: FORM_API_KEY }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getFormContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl:  moduleURLs[FORMS_MODULE],
      },
    })
  }

  return container
}
